// import React from "react";
// import classNames from "classnames";
// import { loadModules } from "esri-loader";
// import { arcgisToGeoJSON } from "@esri/arcgis-to-geojson-utils";

// import Tooltip from "@material-ui/core/Tooltip";
// import { withStyles } from "@material-ui/core";
// import Accordion from "@material-ui/core/Accordion";
// import AccordionSummary from "@material-ui/core/AccordionSummary";
// import Paper from "@material-ui/core/Paper";
// import Grid from "@material-ui/core/Grid";
// import Typography from "@material-ui/core/Typography";
// import Button from "@material-ui/core/Button";
// import AddCircleOutline from "@material-ui/icons/AddCircleOutline"; 
// import useMediaQuery from "@material-ui/core/useMediaQuery";
// import DeleteForever from "@material-ui/icons/DeleteForever";

// const styles = (theme) => ({
//     mobileHeader: {
//         minHeight: "32px !important",
//         height: 32
//     },
//     root: { zIndex: "999", width: "280px", backgroundColor: "#fff" },
//     rootMobile: { zIndex: "999", width: "156px", backgroundColor: "#fff" },
//     buttons: {
//         width: 250,
//         margin: "0px 16px 16px 16px",
//         height: 54,
//     },
//     buttonsMobile: {
//         width: 125,
//         margin: "0px 16px 16px 16px",
//         height: 54,
//     },
//     blueColor: {
//         backgroundColor: "#3c8ac7",
//     },
//     whiteText: {
//         color: "white",
//         marginLeft: 6
//     },
//     rightMargin: {
//         marginRight: "0px !important",
//     },
//     deleteToggled: {
//         border: "2px solid red",
//         backgroundColor: "#005d96",
//     },
// });

// class MapEditing extends React.Component {
//     constructor(props) {
//         super(props);

//         this.state = {
//             latLong: false, // Whether the lat/lon form is opened
//             editing: false, // If we are performing an edit
//             editToggled: false, // Whether the edit button is active or not
//             drawingFeature: false, // Whether the draw button is active or not
//             deleteAllDialog: false, // The delete all geometries dialog window
//             deleteToggled: false, // Whether the delete single geometry button is active or not
//             disabled:false
//         };

//         var _this = this;
//         // Add a new drawing layer  
//         _this.featureGroups = new _this.props.GraphicsLayer();

//         loadModules(["esri/widgets/Sketch/SketchViewModel","esri/geometry/support/webMercatorUtils"], { css: true }).then(([SketchViewModel,webMercatorUtils]) => {
//             _this.sketchVM = new SketchViewModel({
//                 layer: _this.featureGroups,
//                 view: _this.props.view,
//                 updateOnGraphicClick: false,
//                 // updateSymbol when the edit is active
//                 updatePolygonSymbol: {
//                     type: "simple-fill",
//                     style: "solid",
//                     color: "rgba(255, 0, 0, 0.2)",
//                     outline: {
//                         style: "dash",
//                         color: "rgba(255, 0, 0, 1)",
//                         width: 1,
//                     },
//                 },
//                 updatePointSymbol: {
//                     type: "simple-marker",
//                     color: "red",
//                     width: 20,
//                     outline: {
//                         color: [255, 255, 255],
//                         width: 2,
//                     },
//                 },
//                 updatePolylineSymbol: {
//                     type: "simple-line",
//                     color: "red",
//                     width: 5,
//                     cap: "round",
//                     join: "round",
//                 },
//                 // symbols are when drawing
//                 polygonSymbol: {
//                     type: "simple-fill",
//                     style: "solid",
//                     color: "rgba(0, 0, 255, 0.2)",
//                     outline: {
//                         color: "rgba(0, 0, 255, 1)",
//                         width: 1,
//                     },
//                 },
//                 pointSymbol: {
//                     type: "simple-marker",
//                     color: "blue",
//                     width: 20,
//                     outline: {
//                         color: [255, 255, 255],
//                         width: 2,
//                     },
//                 },
//                 polylineSymbol: {
//                     type: "simple-line",
//                     color: "blue",
//                     width: 5,
//                     cap: "round",
//                     join: "round",
//                 },
//             });

//             // Save the drawing while creating
//             _this.sketchVM.on("create", function (event) {
//                 if (event.state === "complete") {
//                     _this.setState({ drawingFeature: false, disabled:true });
//                     var geom, geojson, converted_geom;
//                     geom = event.graphic.geometry; 

//                     if(geom && _this.props.setDrawingFeature){ //used with sandhill app
//                         converted_geom = webMercatorUtils.webMercatorToGeographic(geom);
//                         geojson = arcgisToGeoJSON(converted_geom);

//                         //This function should be used for all other 
//                         _this.props.setDrawingFeature(geojson) //pass upto app component with geometry used with sandhillapp,

//                     }

//                 }
//             });
//         });

//     }

//     componentDidMount() {
//         const { map, view, geometry, Graphic, _getPointGrapicWeb, webMercatorUtils } = this.props;
//         // const {disabled} = this.state
//         const _this = this;



//         if (geometry) {
//             var coord = webMercatorUtils.lngLatToXY(geometry.coordinates[0], geometry.coordinates[1]);
//             var temp = _getPointGrapicWeb("blue", coord[0], coord[1], view, Graphic, null, null);
//             this.featureGroups.add(temp);
//         }

//         map.add(this.featureGroups);

//         // this.populateFeatures();

//         // Click Event
//         view.on("click", function (event) {
//             view.hitTest(event).then(function (response) {
//                 response.results.forEach((x) => {
//                     // Can't do anything without id attributes - This should rarely if ever happen on drawing graphics layer
//                     // It's probably a reference layer
//                     if (!x.graphic.attributes || !x.graphic.attributes["key"] || _this.state.editing) return;

//                     // We are currently deleting - Remove geometry from orm and graphic from layer--was only used when deleting individual geometries
//                     if (_this.state.deleteToggled) {
//                         x.graphic.layer.remove(x.graphic);
//                         _this.setState({disabled:false, deleteToggled:false}) //so let them create another one
//                         return; // Don't do anything else


//                     }

//                     // Check we are working with colored blue (active layer; kinda hacky)
//                     if (x.graphic.symbol.color.b === 255) {
//                         // We are currently editing -
//                         if (_this.state.editToggled) {
//                             _this.setState({ editing: true });

//                             // The default tool for polygons/lines is called "transform" but we don't really want that one
//                             var tool = "move";
//                             if (x.graphic.geometry.type !== "point") tool = "reshape";
//                             _this.sketchVM.update([x.graphic], {
//                                 enableScaling: false,
//                                 tool: tool,
//                             });
//                         }
//                     }
//                 });
//             });
//         });
//     }


//     //only used if we allow for multiple geometries to be deleted--in the application case we just delete them 
//     _onDeleted = () => {
//         var _this = this
//         if (this.featureGroups) {
//             this.featureGroups.graphics.items.forEach(function (g) {
//                 _this.featureGroups.removeAll();
//             })
//             if (_this.props.deleteGeometry) {
//                 _this.props.deleteGeometry();
//             }
//         }
//     }

//     render() {
//         const { classes, readOnly, mediaQuery, application } = this.props;
//         const { latLong, editToggled, drawingFeature, deleteToggled, disabled } = this.state;

//         // readOnly = if there is geometry
//         // application = if editing an application


//                 return (
//                     <Paper>
//                         <Accordion className={mediaQuery ? classes.root : classes.rootMobile} expanded={true}>
//                             <AccordionSummary className={classNames(classes.rightMargin, classes.blueColor, !mediaQuery && classes.mobileHeader)}>
//                                 <Typography variant="subtitle1" className={classes.whiteText}>
//                                     Mapping Tools
//                                 </Typography>
//                             </AccordionSummary>
//                             {!latLong && (
//                                 <Grid container>
//                                     <Grid item xs={12} style={{ marginTop: 12 }}>
//                                         <Tooltip title="Add new map location by clicking on the map."> 
//                                             <div>
//                                                 <Button
//                                                     disabled={
//                                                         application ||
//                                                         (readOnly && this.featureGroups.graphics.length > 0) ||
//                                                         editToggled || 
//                                                         disabled
//                                                     }
//                                                     variant="contained"
//                                                     color="primary"
//                                                     className={classNames(mediaQuery ? classes.buttons : classes.buttonsMobile, drawingFeature && classes.deleteToggled)}
//                                                     onClick={() => {
//                                                         if (drawingFeature) {
//                                                             this.setState({ formDialogStatus: false, drawingFeature: false });
//                                                             this.sketchVM.cancel();
//                                                         } else {
//                                                             this.setState({
//                                                                 formDialogStatus: true,
//                                                                 drawingFeature: true,
//                                                                 editToggled: false,
//                                                                 deleteToggled: false,
//                                                             });

//                                                             this.sketchVM.create("point");
//                                                         }
//                                                     }}>
//                                                     <Typography variant="subtitle1">
//                                                         {drawingFeature
//                                                             ? "Cancel"
//                                                             : mediaQuery ? "Add New Project Location" : "Add Location"}
//                                                     </Typography>
//                                                     <AddCircleOutline style={{ marginLeft: mediaQuery ? 20 : 5 }} />
//                                                 </Button>
//                                             </div>
//                                         </Tooltip>
//                                          <Tooltip
//                                             title={
//                                                 this.featureGroups.graphics.length === 0
//                                                     ? "This button clears project location":null
//                                             }>
//                                             <div>
//                                                 <Button
//                                                     disabled={
//                                                         application ||
//                                                         this.featureGroups.graphics.length === 0 ||
//                                                         editToggled ||
//                                                         deleteToggled ||
//                                                         drawingFeature
//                                                     }
//                                                     variant="contained"
//                                                     color="primary"
//                                                     className={classNames(mediaQuery ? classes.buttons : classes.buttonsMobile)}
//                                                     onClick={(e) => {
//                                                         this._onDeleted();
//                                                         this.setState({ deleteAllDialog: false, editToggled: false, disabled:false});
//                                                     }}>
//                                                     <Typography variant="subtitle1">{mediaQuery ? "Delete Project Location" : "Delete Location"}</Typography>
//                                                     <DeleteForever style={{ marginLeft: mediaQuery ? 20 : 5 }} />
//                                                 </Button>
//                                             </div>
//                                         </Tooltip>  
//                                     </Grid>
//                                 </Grid>
//                             )}
//                         </Accordion>


//                     </Paper>
//                 );

//     }
// }
// MapEditing.displayName = "MapEditingApplication";

// const withMediaQuery = (...args) => Component => props => {
//     const mediaQuery = useMediaQuery(...args);
//     return <Component mediaQuery={mediaQuery} {...props} />;
// };

// export default withStyles(styles)(withMediaQuery('(min-width:960px)')(MapEditing));



import React from "react";
import classNames from "classnames";
import { loadModules } from "esri-loader";
import { arcgisToGeoJSON } from "@esri/arcgis-to-geojson-utils";
import Tooltip from "@material-ui/core/Tooltip";
import { withStyles } from "@material-ui/core";
import Accordion from "@material-ui/core/Accordion";
import AccordionSummary from "@material-ui/core/AccordionSummary";
import Paper from "@material-ui/core/Paper";
import Grid from "@material-ui/core/Grid";
import Typography from "@material-ui/core/Typography";
import Button from "@material-ui/core/Button";
import AddCircleOutline from "@material-ui/icons/AddCircleOutline";
import useMediaQuery from "@material-ui/core/useMediaQuery";
import DeleteForever from "@material-ui/icons/DeleteForever";
import AddLocation from "@material-ui/icons/AddLocation";
import { Form as FormMap } from "react-form";


// import TextField from "../../common/TextField";
import AccTextField from "../../common/commonAccessability/accessabilityTextField.js";
// import HelpLabel from "../../common/HelpLabel";
import AccHelpLabel from "../../common/commonAccessability/accessabilityHelpLabel.js";


const styles = (theme) => ({
    mobileHeader: {
        minHeight: "32px !important",
        height: 32
    },
    root: { zIndex: "999", width: "280px", backgroundColor: "#fff" },
    rootMobile: { zIndex: "999", width: "156px", backgroundColor: "#fff" },
    buttons: {
        width: 250,
        margin: "0px 16px 16px 16px",
        height: 54,
        backgroundColor: "#2845D6",
    },
    buttonColor: {
        backgroundColor: "#2845D6",
        color: "white"
    },
    buttonsMobile: {
        width: 125,
        margin: "0px 16px 16px 16px",
        height: 54,
    },
    blueColor: {
        // backgroundColor: "#3c8ac7",
        backgroundColor: "#2845D6",
    },
    whiteText: {
        color: "white",
        marginLeft: 6
    },
    rightMargin: {
        marginRight: "0px !important",
    },
    deleteToggled: {
        border: "2px solid red",
        backgroundColor: "#005d96",
    },
});

class MapEditing extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            latLong: false, // Whether the lat/lon form is opened
            editing: false, // If we are performing an edit
            editToggled: false, // Whether the edit button is active or not
            drawingFeature: false, // Whether the draw button is active or not
            deleteAllDialog: false, // The delete all geometries dialog window
            deleteToggled: false, // Whether the delete single geometry button is active or not
            disabled: false,
        };

        var _this = this;
        // Add a new drawing layer  
        _this.featureGroups = new _this.props.GraphicsLayer();

        loadModules(["esri/widgets/Sketch/SketchViewModel", "esri/geometry/support/webMercatorUtils", 'esri/rest/locator'], { css: true }).then(([SketchViewModel, webMercatorUtils, locator]) => {
            _this.sketchVM = new SketchViewModel({
                layer: _this.featureGroups,
                view: _this.props.view,
                updateOnGraphicClick: false,
                // updateSymbol when the edit is active
                updatePolygonSymbol: {
                    type: "simple-fill",
                    style: "solid",
                    color: "rgba(255, 0, 0, 0.2)",
                    outline: {
                        style: "dash",
                        color: "rgba(255, 0, 0, 1)",
                        width: 1,
                    },
                },
                updatePointSymbol: {
                    type: "simple-marker",
                    color: "red",
                    width: 20,
                    outline: {
                        color: [255, 255, 255],
                        width: 2,
                    },
                },
                updatePolylineSymbol: {
                    type: "simple-line",
                    color: "red",
                    width: 5,
                    cap: "round",
                    join: "round",
                },
                // symbols are when drawing
                polygonSymbol: {
                    type: "simple-fill",
                    style: "solid",
                    color: "rgba(0, 0, 255, 0.2)",
                    outline: {
                        color: "rgba(0, 0, 255, 1)",
                        width: 1,
                    },
                },
                pointSymbol: {
                    type: "simple-marker",
                    color: "blue",
                    width: 20,
                    outline: {
                        color: [255, 255, 255],
                        width: 2,
                    },
                },
                polylineSymbol: {
                    type: "simple-line",
                    color: "blue",
                    width: 5,
                    cap: "round",
                    join: "round",
                },
            });

            _this.sketchVM.on("create", function (event) {
                if (event.state === "complete") {
                    _this.setState({ drawingFeature: false });
                    const geoType = _this.props.geoType;
                    var geojson, converted_geom;

                    // // Add attributes for the popup that is already in the feature group
                    // Get a point to reverse‑geocode 
                    const geom = event.graphic.geometry;
                    const point = geom.type === "point" ? geom : geom.extent.center;

                    locator.locationToAddress(
                        "https://geocode.arcgis.com/arcgis/rest/services/World/GeocodeServer",
                        { location: point }
                    ).then((response) => {
                        const addr = response.attributes;

                        event.graphic.attributes = {
                            address: addr.Address,
                            city: addr.City,
                            state: addr.Region,
                            zip: addr.Postal
                        };

                        event.graphic.popupTemplate = {
                            title: "Location",
                            content: `
                            <b>Address:</b> {address}<br>
                            <b>City:</b> {city}<br>
                            <b>State:</b> {state}<br>
                            <b>ZIP:</b> {zip}
                        `
                        };
                    });


                    // Your existing geojson conversion logic. rerun to get new multipoint values with passing back to the applications
                    if (geom && _this.props.setDrawingFeature) {
                        if (geoType === 'Point') {
                            converted_geom = webMercatorUtils.webMercatorToGeographic(geom);
                            geojson = arcgisToGeoJSON(converted_geom);
                        }
                        else if (geoType === 'MultiPoint') {//MULTIPOINT
                            converted_geom = [];
                            // First get a array of the prior latlong geometries in geojson
                            _this.featureGroups.graphics.items.forEach(function (graph) {
                                converted_geom.push(
                                    arcgisToGeoJSON(
                                        _this.props.webMercatorUtils.webMercatorToGeographic(graph.geometry)
                                    )
                                );
                            });
                            //pass new points back to app
                            geojson = {
                                type: 'MultiPoint',
                                coordinates: converted_geom.map((cg) => cg.coordinates)
                            };
                        }

                        _this.props.setDrawingFeature(geojson);
                    }
                }
            });

        });

    }

    getPopUpInfo = (x, y, locator) => {
        const { view, Graphic, _getPointGrapicWeb, webMercatorUtils, geoType } = this.props;
        let [x_, y_] = webMercatorUtils.lngLatToXY(x, y);

        const point = {
            type: "point",
            longitude: x,
            latitude: y,
            spatialReference: view.spatialReference
        };

        //get the address to load with the popup
        return locator.locationToAddress(
            "https://geocode-api.arcgis.com/arcgis/rest/services/World/GeocodeServer",
            { location: point }
        ).then(response => {

            const addr = response.attributes;

            const graphic = _getPointGrapicWeb(
                "blue",
                x_,
                y_,
                view,
                Graphic,
                {
                    address: addr.Address,
                    city: addr.City,
                    state: addr.Region,
                    zip: addr.Postal
                },
                {
                    title: "Location",
                    content: `
                        <b>Address:</b> {address}<br>
                        <b>City:</b> {city}<br>
                        <b>State:</b> {state}<br>
                        <b>ZIP:</b> {zip}
                    `
                }
            );
            this.featureGroups.add(graphic);
        })

    }

    componentDidMount() {
        const { map, view, geometry, geoType } = this.props;
        // const {disabled} = this.state
        const _this = this;


        map.add(this.featureGroups);

        if (geometry) {
            if (geoType === 'Point') {
                _this.setState({ disabled: true })
            }
            loadModules(['esri/rest/locator']).then(([locator]) => {
                if (geoType === 'Point' || (geoType === 'MultiPoint' && geometry.type === 'Point')) {// for priors within nmc as they went to multipoints but we need to handle old records that were points

                    this.getPopUpInfo(geometry.coordinates[0], geometry.coordinates[1], locator)
                } else if (geoType === 'MultiPoint') {
                    // Collect all async reverse‑geocode promises
                    const tasks = geometry.coordinates.map(coord => {

                        this.getPopUpInfo(coord[0], coord[1], locator)

                    });

                    // Wait for ALL points to be added before zooming
                    Promise.all(tasks).then(() => {
                        view.goTo(this.featureGroups.graphics.items);
                    });
                }
            });
        }

        //RG: is this even needed? 
        // Click Event
        view.on("click", function (event) {
            view.hitTest(event).then(function (response) {
                response.results.forEach((x) => {
                    // Can't do anything without id attributes - This should rarely if ever happen on drawing graphics layer
                    // It's probably a reference layer
                    if (!x.graphic.attributes || !x.graphic.attributes["key"] || _this.state.editing) return;


                    // We are currently deleting - Remove geometry from orm and graphic from layer--was only used when deleting individual geometries
                    if (_this.state.deleteToggled) {
                        x.graphic.layer.remove(x.graphic);
                        _this.setState({ disabled: false, deleteToggled: false }) //so let them create another one
                        return; // Don't do anything else

                    }

                    // Check we are working with colored blue (active layer; kinda hacky)
                    if (x.graphic.symbol.color.b === 255) {
                        // We are currently editing -
                        if (_this.state.editToggled) {
                            _this.setState({ editing: true });

                            // The default tool for polygons/lines is called "transform" but we don't really want that one
                            var tool = "move";
                            if (x.graphic.geometry.type !== "point") tool = "reshape";
                            _this.sketchVM.update([x.graphic], {
                                enableScaling: false,
                                tool: tool,
                            });
                        }
                    }
                });
            });
        });
    }

    //only used if we allow for multiple geometries to be deleted--in the application case we just delete them 
    _onDeleted = () => {
        var _this = this
        if (this.featureGroups) {
            this.featureGroups.graphics.items.forEach(function (g) {
                _this.featureGroups.removeAll();
            })
            if (_this.props.deleteGeometry) {
                _this.props.deleteGeometry();
            }
        }
    }
    // Ex: 43.647752,-94.079618, for ADA compliance  
    latCreateMarker = (event) => {
        const { webMercatorUtils, _getPointGrapicWeb, Graphic, view, map, geoType } = this.props;

        if (geoType === 'Point') {
            this.setState({ disabled: true })
        }

        const coords = event.lat//break apart coords by semicolon
            .split(";")
            .map(pair => pair.split(","))
            .map(([lat, lon]) => [parseFloat(lon), parseFloat(lat)]);

        coords.forEach(c => {
            const [x, y] = webMercatorUtils.lngLatToXY(c[0], c[1]);
            const graphic = _getPointGrapicWeb("blue", x, y, view, Graphic, null, null);
            this.featureGroups.add(graphic);
        });



        let geojson;
        // determine if its a point or multiple to pass back to app
        if (geoType === "Point") {
            const [x, y] = webMercatorUtils.lngLatToXY(coords[0][0], coords[0][1]);
            const wmPoint = { type: "point", x, y, spatialReference: view.spatialReference };
            const geographic = webMercatorUtils.webMercatorToGeographic(wmPoint);
            geojson = arcgisToGeoJSON(geographic);
        }
        else if (geoType === 'MultiPoint') {
            const converted = this.featureGroups.graphics.items.map(graph =>
                arcgisToGeoJSON(
                    webMercatorUtils.webMercatorToGeographic(graph.geometry)
                )
            );
            geojson = {
                type: "MultiPoint",
                coordinates: converted.map(cg => cg.coordinates)
            };
        }
        //pass new points back to app  
        this.props.setDrawingFeature(geojson);

        if (!map.layers.includes(this.featureGroups)) {
            map.add(this.featureGroups);
        }

        view.when(() => {
            view.goTo(this.featureGroups.graphics.items);
        });
    };



    render() {
        const { classes, readOnly, mediaQuery, application, geoType } = this.props;
        const { latLong, editToggled, drawingFeature, deleteToggled, disabled } = this.state;

        // readOnly = if there is geometry
        // application = if editing an application
        let geoTypeText = geoType === "MultiPoint" ? "Multiple latitude and longitude points can be added by separating them with a semicolon. (i.e. 43.647,-94.079;44.123,-93.456)" : "Enter the latitude and longitude for the project location.";

        return (
            <Paper>
                <Accordion className={mediaQuery ? classes.root : classes.rootMobile} expanded={true}>
                    <AccordionSummary className={classNames(classes.rightMargin, classes.blueColor, !mediaQuery && classes.mobileHeader)}>
                        <Typography
                            // variant="subtitle1"
                            className={classes.whiteText}
                            variant="h1"
                            style={{
                                // font-size: 1rem;
                                fontSize: 17,
                                // font-weight: 400;
                                fontWeight: 400,
                                // line-height: 1.75;
                                lineHeight: 1.75,
                                marginLeft: 16
                            }}
                        >
                            Mapping Tools
                        </Typography>
                    </AccordionSummary>
                    {!latLong && (
                        <Grid container>
                            <Grid item xs={12} style={{ marginTop: 12 }}>
                                <Tooltip title="Add new map location by clicking on the map.">
                                    <div>
                                        <Button
                                            disabled={
                                                application || // if there is and application but isnt a 'saved not completed' status application (refer to nmc permit)
                                                editToggled ||
                                                disabled ||
                                                (readOnly && this.featureGroups.graphics.length > 0) || //disabled = disableSearch prop from application 
                                                (geoType === 'Point' && this.featureGroups.graphics.length > 0) // Only allow one point if geoType is 'Point'
                                            }
                                            variant="contained"
                                            color="primary"
                                            className={classNames(mediaQuery ? classes.buttons : classes.buttonsMobile, drawingFeature && classes.deleteToggled)}
                                            onClick={() => {
                                                if (drawingFeature) {
                                                    this.setState({ formDialogStatus: false, drawingFeature: false });
                                                    this.sketchVM.cancel();
                                                } else {
                                                    this.setState({
                                                        formDialogStatus: true,
                                                        drawingFeature: true,
                                                        editToggled: false,
                                                        deleteToggled: false,
                                                    });

                                                    this.sketchVM.create("point");
                                                }
                                            }}>
                                            <Typography
                                                // variant="subtitle1"
                                                variant="h2"
                                                style={{
                                                    // font-size: 1rem;
                                                    fontSize: 14,
                                                    // font-weight: 400;
                                                    fontWeight: 400,
                                                    // line-height: 1.75;
                                                    lineHeight: 1,
                                                    marginLeft: 16
                                                }}
                                            >
                                                {drawingFeature
                                                    ? "Cancel"
                                                    : mediaQuery ? "Add New Project Location" : "Add Location"}
                                            </Typography>
                                            <AddCircleOutline style={{ marginLeft: mediaQuery ? 20 : 5 }} />
                                        </Button>
                                    </div>
                                </Tooltip>
                                <Tooltip
                                    title={
                                        this.featureGroups.graphics.length === 0
                                            ? "This button clears project location" : null
                                    }>
                                    <div>
                                        <Button
                                            disabled={
                                                application || // if there is and application but isnt a 'saved not completed' status application (refer to nmc permit)
                                                editToggled ||
                                                deleteToggled ||
                                                drawingFeature
                                            }
                                            variant="contained"
                                            color="primary"
                                            className={classNames(mediaQuery ? classes.buttons : classes.buttonsMobile)}
                                            onClick={(e) => {
                                                this._onDeleted();
                                                this.setState({ deleteAllDialog: false, editToggled: false, disabled: false });
                                            }}>
                                            <Typography
                                                // variant="subtitle1"
                                                variant="h2"
                                                style={{
                                                    // font-size: 1rem;
                                                    fontSize: 14,
                                                    // font-weight: 400;
                                                    fontWeight: 400,
                                                    // line-height: 1.75;
                                                    lineHeight: 1,
                                                    marginLeft: 16
                                                }}
                                            >
                                                {mediaQuery ? "Delete Project Location" : "Delete Location"}
                                            </Typography>
                                            <DeleteForever style={{ marginLeft: mediaQuery ? 20 : 5 }} />
                                        </Button>
                                    </div>
                                </Tooltip>
                                <Tooltip title="Add a new point location by entering latitude and longitude coordinates.">
                                    <div>
                                        <Button
                                            disabled={
                                                application ||
                                                editToggled ||
                                                disabled ||
                                                drawingFeature ||
                                                (geoType === 'Point' && this.featureGroups.graphics.length > 0) // Only allow one point if geoType is 'Point'
                                            }
                                            variant="contained"
                                            color="primary"
                                            className={classes.buttons}
                                            onClick={() => {
                                                this.setState({ latLong: true });

                                            }}>
                                            <Typography
                                                disabled={readOnly}
                                                // variant="subtitle1"
                                                variant="h2"
                                                style={{
                                                    // font-size: 1rem;
                                                    fontSize: 14,
                                                    // font-weight: 400;
                                                    fontWeight: 400,
                                                    // line-height: 1.75;
                                                    lineHeight: 1,
                                                    marginLeft: 16
                                                }}
                                            >
                                                Add Point by Lat/Long Values
                                            </Typography>
                                            <AddLocation style={{ marginLeft: 20 }} />
                                        </Button>
                                    </div>
                                </Tooltip>

                            </Grid>
                        </Grid>
                    )}
                    {latLong && (
                        <FormMap
                            dontValidateOnMount={true}
                            // validateOnSubmit={true}
                            onSubmit={(values) => {
                                this.setState({ latLong: false });
                                this.latCreateMarker(values);
                            }}>
                            {(formApi2) => (
                                <form onSubmit={formApi2.submitForm}>
                                    <Grid container spacing={3} style={{ padding: "8px 16px 16px" }}>
                                        <Grid item xs={12}>
                                            <AccTextField
                                                field="lat"
                                                fullWidth
                                                placeholder="Ex: 43.647,-94.079"
                                                label={
                                                    <AccHelpLabel
                                                        inputLabel={"Latitude/Longitude"}
                                                        helpText={geoTypeText} />
                                                }
                                            />
                                        </Grid>
                                        <Grid item xs={12}>
                                            <Button
                                                onClick={() => formApi2.submitForm()}
                                                variant="contained"
                                                // color="primary"
                                                fullWidth
                                                className={classes.buttonColor}
                                            >
                                                Create Coord Marker
                                            </Button>
                                        </Grid>
                                        <Grid item xs={12}>
                                            <Button
                                                variant="contained"
                                                // color="primary"
                                                className={classes.buttonColor}
                                                fullWidth
                                                onClick={() => {
                                                    this.setState({ latLong: false });
                                                }}>
                                                Cancel
                                            </Button>
                                        </Grid>
                                    </Grid>
                                </form>
                            )}
                        </FormMap>
                    )}
                </Accordion>
            </Paper>
        );

    }
}
MapEditing.displayName = "MapEditingApplication";

const withMediaQuery = (...args) => Component => props => {
    const mediaQuery = useMediaQuery(...args);
    return <Component mediaQuery={mediaQuery} {...props} />;
};

export default withStyles(styles)(withMediaQuery('(min-width:960px)')(MapEditing));
